import React, { useState } from 'react'
import Select from 'react-select'
import { useDispatch, useStore } from 'react-redux'
import { Modal } from 'rsuite'
import { toast } from '../../../components/CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { doGetDomainRequestorsByDomain, doInviteUserToDomain } from '../../../redux/actions/domain'
import DomainSignupModal from '../modals/domain-signup'

const DomainInviteModal = ({ show, onClose, roleOptions, selectedDomain }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const {
    domain: { isLoading },
  } = store

  const [role, setRole] = useState(roleOptions[0])
  const [userEmail, setUserEmail] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [showSignupModal, setShowSignupModal] = useState(false)

  const handleChangeRole = (val) => {
    setRole(val)
  }

  const handleInviteUserToDomain = () => {
    if (!role) {
      toast.show({
        title: 'Warning',
        description: 'Role is required',
      })
      return
    }
    if (userEmail === '') {
      toast.show({
        title: 'Warning',
        description: 'Email is required',
      })
      return
    } 
    
    dispatch(
      doInviteUserToDomain({
        domainId: selectedDomain?.id,
        userEmail,
        roleId: role.value,
        firstName,
        lastName

      })

    ).then(() => {
      dispatch(doGetDomainRequestorsByDomain({domainId: selectedDomain.id}))
      onClose()
      //setShowSignupModal(true)
    })
  }

  const handleCloseSignupModal = () => {
    //setShowSignupModal(false)
  }

  return (
    <Modal
      backdrop={'static'}
      className="domain-invite-modal"
      show={show}
      size="xs"
      onClick={onClose}
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title className='text-black fw-bold'>
          Invite user to domain
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={`invite-domain ${isLoading ? 'loading' : ''}`}>
          {isLoading && <LoaderComponent />}
          <div className="content">
            <div className="list">
              <div className='item'>
                <label className='h4 mb-0 text-black mb-2'>To: </label>
                <input type="text" placeholder="name@gmail.com" className='search-input' defaultValue={userEmail} onChange={e => setUserEmail(e.target.value)} />
              </div>
            </div>
            <div className="list">
              <div className='item'>
                <label className='h4 mb-0 text-black mb-2'>First Name: </label>
                <input type="text" placeholder="John" className='search-input' defaultValue={firstName} onChange={e => setFirstName(e.target.value)} />
              </div>
            </div>
            <div className="list">
              <div className='item'>
                <label className='h4 mb-0 text-black mb-2'>Last Name: </label>
                <input type="text" placeholder="Smith" className='search-input' defaultValue={lastName} onChange={e => setLastName(e.target.value)} />
              </div>
            </div>
            <div className='item'>
              <label className='h4 mb-0 text-black mb-2'>Invite as: </label>
              <Select
                className="role-option h4 mb-0"
                options={roleOptions}
                value={role}
                onChange={handleChangeRole}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="action-container">
          <button type="button" disabled={isLoading} className="h4 mb-0 pt-2 pb-2 width-100 rounded btn-green" onClick={handleInviteUserToDomain}>
            Invite
          </button>
        </div>
      </Modal.Footer>
      <DomainSignupModal
        show={showSignupModal}
        onClose={handleCloseSignupModal}
        userEmail={userEmail}
      />
    </Modal>
  )
}

export default DomainInviteModal